import React from 'react';

// Shared tone palette + icon set for the "top insight" cards across the
// dashboard (Google Ads VerdictCard, Event Intelligence VerdictCard,
// Competitive Intelligence VerdictCard). These were copied byte-for-byte into
// each card; consolidated here so a palette/icon tweak is a one-file change.
//
// `gray` intentionally uses the blue/indigo gradient — it's the neutral
// "insufficient data / steady" tone, and the brand-blue wash reads as calm,
// not as an error. `dot` is the chip-marker color used in the card's CTA row.
export const TONES = {
  emerald: {
    bg: 'bg-gradient-to-r from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20',
    border: 'border-emerald-200 dark:border-emerald-800/50',
    divider: 'border-emerald-200/50 dark:border-emerald-700/30',
    icon: 'text-emerald-500',
    dot: 'bg-emerald-500',
  },
  amber: {
    bg: 'bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20',
    border: 'border-amber-200 dark:border-amber-800/50',
    divider: 'border-amber-200/50 dark:border-amber-700/30',
    icon: 'text-amber-500',
    dot: 'bg-amber-500',
  },
  red: {
    bg: 'bg-gradient-to-r from-red-50 to-rose-50 dark:from-red-900/20 dark:to-rose-900/20',
    border: 'border-red-200 dark:border-red-800/50',
    divider: 'border-red-200/50 dark:border-red-700/30',
    icon: 'text-red-500',
    dot: 'bg-red-500',
  },
  gray: {
    bg: 'bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20',
    border: 'border-blue-200 dark:border-blue-800/50',
    divider: 'border-blue-200/50 dark:border-blue-700/30',
    icon: 'text-blue-500',
    dot: 'bg-gray-400',
  },
};

// Icon glyphs (SVG path/polygon children) keyed by verdict mood. Rendered inside
// a `<svg viewBox="0 0 24 24" stroke="currentColor">` by the consuming card.
export const ICONS = {
  trophy: <path d="M8 21h8M12 17v4M7 4h10v4a5 5 0 0 1-10 0V4zM5 4H3v2a3 3 0 0 0 3 3M19 4h2v2a3 3 0 0 1-3 3" />,
  alert: (
    <>
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </>
  ),
  bolt: <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />,
  compass: (
    <>
      <circle cx="12" cy="12" r="10" />
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
    </>
  ),
};
